module.exports = __webpack_public_path__ + "8344062298f2189068894c1da20706c6.jpg";